import React from 'react';
import PropTypes from 'prop-types';
import styles from './SoilSsurgoZoneRows.css';

function SoilSsurgoZoneRows({
  activeZoneIndex,
  onClick,
  zones = [],
  activeLayer,
}) {
  const testId = 'soil-ssurgo';

  return (
    <tbody>
      {zones.map((zone, index) => {
        const circleColor = { backgroundColor: zone.color };
        const isActive = activeZoneIndex === index;
        const rowStyles = activeZoneIndex === index ? styles.active : '';
        return (
          <tr
            className={rowStyles}
            data-is-active={isActive}
            data-test-id={`${testId}-row-${index}`}
            id={index}
            key={zone.color}
            onClick={onClick}
          >
            <td data-test-id={`${testId}-row-area-value-${index}`}>
              <div className={styles.circle} style={circleColor} />
              {zone.area}
            </td>
            {activeLayer && (
              <td data-test-id={`${testId}-row-soil-type-value-${index}`}>
                {zone[activeLayer]}
              </td>
            )}
          </tr>
        );
      })}
    </tbody>
  );
}

SoilSsurgoZoneRows.propTypes = {
  activeLayer: PropTypes.string,
  activeZoneIndex: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  zones: PropTypes.array.isRequired,
};

export default SoilSsurgoZoneRows;
